import { Cast } from '@/types/casts'
import Vue from 'vue'

export default Vue.extend({
  computed: {
    currentCast (): Cast | undefined {
      return this.$store.direct.state.events.currentCast
    }
  },
  watch: {
    currentCast: {
      handler (newVal: Cast| undefined, oldVal: Cast | undefined) {
        if (oldVal) this.unsubscribe(oldVal.id)
        if (newVal) this.subscribe(newVal.id)
      },
      immediate: true
    }
  },
  beforeDestroy () {
    if (this.currentCast) this.unsubscribe(this.currentCast.id)
  },
  methods: {
    subscribe (cast: string | undefined) {
      if (cast) {
        console.log('subscribe cast is ', cast)
        this.$store.direct.dispatch.bots.subscribeBots(cast)
      }
    },
    unsubscribe (cast: string | undefined) {
      if (cast) {
        this.$store.direct.dispatch.bots.unsubscribeBots(cast)
      }
    }
  }
})
